import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRegionLoading, EGetRegionActionTypes } from './types';

export const getRegionLoading: () => TGetRegionLoading = actionGenerator<EGetRegionActionTypes.Loading>(
  EGetRegionActionTypes.Loading,
);
